<template><!--mobile-->
    <div class="mobile-edit">
        <el-card class="profile">
            <div slot="header" class="clearfix">
                <span class="text-info">
                #{{$route.params.id?$route.params.id:'新建'}} {{single.topic}} </span>
                <div class="float-right" style=" padding: 3px 0; font-size:14px;">
                    <span class="text-info"> {{single.approve_status}} </span></div>
            </div>

            <div class="mt-1">
                <el-form :model="single" ref="MeetingForm" label-width="4em">
                    <el-row>
                        <el-col>
                            <el-form-item
                                    prop="topic"
                                    label="主题:"
                                    :rules="[{ required: true, message: '请输入主题', trigger: 'blur' }]">
                                <el-input v-model="single.topic" clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item
                                    prop="password"
                                    label="密码:">

                                <el-input v-model="single.password" clearable
                                          placeholder="0-8位纯数字"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item
                                    prop="room_groups"
                                    label="会组:" style="margin-bottom: 0; ">
                                <select v-model="single.group_id" class="w-100 mobile-select">
                                    <option
                                            v-for="item in allRoomGroups"
                                            :key="item.id"
                                            :value="item.id">{{item.name}}
                                    </option>
                                </select>
                            </el-form-item>
                        </el-col>
                        <div class="mb-4">
                            <meeting-freebusy ref="meeting_busy"
                                              :h323="single.option_h323"
                                              @change='handleFreeChange'
                                              size="small"
                                              :jump="false" :group="single.group_id"
                                              :duration="single.duration"
                                              :time="single.meeting_time"
                                              :date="single.meeting_date" :id="single.id">
                            </meeting-freebusy>
                        </div>
                        <el-col>
                            <el-form-item prop="meeting_date" label="日期:"
                                          :rules="[{ required: true, message: '请输入日期', trigger: 'blur' }]">
                                <el-input class="w-100 bg-light" type="date" v-model="single.meeting_date"></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col>
                            <el-form-item
                                    prop="meeting_time"
                                    label="时间:"
                                    :rules="[{ required: true, message: '请输入时间', trigger: 'blur' }]">
                                <select v-model="single.meeting_time" class="mobile-select w-100" :disabled="!canAdd">
                                    <option v-for="item in time_options"
                                            :key="item"
                                            :value="item">
                                        {{item}}
                                    </option>
                                </select>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item style="margin-bottom: 0;"
                                          prop="duration"
                                          label="时长:"
                                          value-format="HH-mm-ss"
                                          :rules="[{ required: true, message: '请输入时长', trigger: 'blur' }]">
                                <select v-model="single.duration" class="mobile-select w-100" :disabled="!canAdd">
                                    <option v-for="item in duration_options"
                                            :key="item.value"
                                            :value="item.value">
                                        {{item.label}}
                                    </option>
                                </select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="mb-2">
                        <div class="meeting-time-reminder text-right"><i class="fa fa-info"></i>
                            参会人可在:{{join_meeting_at}} 入会, <br/>
                            系统将在:{{end_meeting_at}} 结束会议
                        </div>
                    </el-row>
                    <el-row>
                        <div class="date-time-reminder" v-show="need_approval"><i class="fa fa-info"></i>
                            {{single.id?'修改日期和时间以及时长，将需要重新审批。':'保存后将提交给管理员审批'}}
                        </div>
                    </el-row>
                    <el-row>
                        <el-form-item v-if="!invisible"
                                prop="usage"
                                label="用途:">
                            <select v-model="single.usage" class="w-100 mobile-select">
                                <option
                                        v-for="item in preset.app.usages"
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                </option>
                            </select>
                        </el-form-item>
                    </el-row>
                    <el-row :span="8" v-if="isTencentMeeting && $organization.cohost">
                        <el-form-item
                            prop="topic"
                            label="联席:">
                            <el-input v-model="single.assistants" placeholder="请输入联席主持人工号"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row v-if="isWelinkMeeting">
                        <el-form-item
                            prop="size"
                            label="规模:" >
                            <el-select v-model="single.size" placeholder="填写规模" class="w-100">
                                <el-option
                                    v-for="item in sizes"
                                    :key="item"
                                    :label="item+'人'"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item
                                prop="description"
                                label="描述:">
                            <el-input type="textarea" v-model="single.description" :rows="2"></el-input>
                        </el-form-item>
                    </el-row>
                    <el-row :gutter="5" type="flex"  v-if="!$organization.use_label">
                        <el-col class="flex-grow-1">
                            <div class="el-form-item">
                                <label class="el-form-item__label"
                                       style="width: 60px;color: #2196f3">参会者:
                                </label>
                                <div class="el-form-item__content" style="margin-left: 60px;">
                                    <div class="el-textarea">
                                        <div class="el-textarea__inner"
                                             style="min-height: 60px;">
                                            <div v-for="(item,index) in emails" :key="item.emails"
                                                 style="display: inline-block">
                                                {{index===0?'':', '}}{{item.name}}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-col>
                        <el-col class="flex-grow-0" style="width: 60px;">
                            <button style="width: 100%;height: 60px" type="button" class="btn btn-secondary"
                                    @click="handleAddressBook">
                                <i class="fa fa-address-book-o"></i>
                            </button>
                        </el-col>
                    </el-row>
                    <mh-label-select v-model="single.label" class="mb-4"></mh-label-select>

                    <el-row type="flex"
                            style="flex-wrap: wrap; padding-left: 60px;justify-content: space-between">
                        <div style="min-width: 7em;margin-bottom: 10px;"  v-show="4 != roomGroupPlatform">
                            <el-switch v-model="single.waiting_room"
                                       @change="single.option_jbh = single.waiting_room?0:single.option_jbh"
                                       active-text="等候室"
                                       :active-value="1"
                                       :inactive-value="0">
                            </el-switch>
                        </div>
                        <div style="min-width: 7em;margin-bottom: 10px;">
                            <el-switch v-model="single.option_jbh"
                                       @change="single.waiting_room = single.option_jbh?0:single.waiting_room"
                                       active-text="提前参会"
                                       active-value="1"
                                       inactive-value="0">
                            </el-switch>
                        </div>
                        <div style="min-width: 7em;margin-bottom: 10px;display: none;">
                            <el-switch v-model="single.option_mute"
                                       active-text="静音入会"
                                       active-value="1"
                                       inactive-value="0">
                            </el-switch>
                        </div>
                        <div style="min-width: 7em;margin-bottom: 10px;" >
                            <el-switch v-model="single.option_interpreter" :disabled="single && single.id && isTencentMeeting"
                                       active-text="开启同传"
                                       active-value="1"
                                       inactive-value="0">
                            </el-switch>
                        </div>
                        <div style="min-width: 7em;margin-bottom: 10px;" v-if="isTencentMeeting && !$organization.hide_option_live">
                            <el-switch v-model="single.option_live"
                                       active-text="开启直播"
                                       active-value="1"
                                       inactive-value="0">
                            </el-switch>
                        </div>
                        <div style="min-width: 7em;margin-bottom: 10px;" v-if="isTencentMeeting && !$organization.hide_option_internal">
                            <el-switch v-model="single.option_sso_only"
                                       active-text="仅内部用户"
                                       active-value="1"
                                       inactive-value="0">
                            </el-switch>
                        </div>
                        <div style="min-width: 7em;margin-bottom: 10px;" v-if="isTencentMeeting">
                            <el-switch v-model="single.option_water_mark"
                                       active-text="启用水印"
                                       active-value="1"
                                       inactive-value="0">
                            </el-switch>
                        </div>
                        <div style="min-width: 7em;margin-bottom: 10px;" v-if="!invisible">
                            <el-select v-model="single.auto_record" size="small" style="width: 120px"
                                       placeholder="选择录像方案">
                                <el-option label="手动录制" :value="0"></el-option>
                                <el-option label="自动本地" :value="1"></el-option>
                                <el-option label="自动云端" :value="2"></el-option>
                            </el-select>
                        </div>
                    </el-row>

                    <el-row>
                        <div class="">
                            <el-checkbox v-model="single.quite" style="padding-top: 20px;">
                                {{!single.quite?'自动发邮件通知参会者':'自动发邮件通知参会者'}}
                            </el-checkbox>
                        </div>
                    </el-row>
                </el-form>
            </div>

            <el-row>
                <div class="line"></div>
                <el-button :loading="is_loading" class="mt-3" type="primary" @click="handleSubmit">
                    {{need_approval?'提交审批':'保存修改'}}
                </el-button>
                <el-button :loading="is_loading" class="mt-3" type="default" @click="$router.go(-1)">
                    返回我的会议
                </el-button>
            </el-row>

        </el-card>

        <address-book-picker :edit_mode="address_book_visible" :address_book="emails" @cancel="handleCancel"
                             @success="handleSuccess">
        </address-book-picker>

    </div>
</template>

<script>

    import MeetingFreebusy from "../../components/Meeting-FreeBusy";
    import AddressBookPicker from "../../components/address-book-mobile-picker";
    import editMixin from "../../common/mixins/front-edit-mixin";
    import MhLabelSelect from "../../components/mh-label-select.vue";

    export default {
        name: "edit",
        mixins: [editMixin],
        components: {MhLabelSelect, AddressBookPicker, MeetingFreebusy},
        data() {
            return {
                time_options: []
            }
        },
        created() {
            for (let i = 0; i < 24; i++) {
                for (let j = 0; j < 60; j += 30) {
                    this.time_options.push(('0' + i).slice(-2) + ':' + ('0' + j).slice(-2));
                }
            }
        }
    }
</script>

<style lang="scss">
    .mobile-edit {
        .mobile-select {
            height: 40px;
            border: 1px solid #e2e5ea;
            padding: 0 10px;
            background-color: white;
            width: 100%;
            color: #606266
        }

        .date-time-reminder {
            font-size: 13px;
            color: #0288D1;
            text-align: right;
        }

        .meeting-time-reminder {
            position: relative;
            color: #607D8B;
            font-size: 13px;
        }

        .attendee-block {
            display: inline-block;
            border-radius: 5px;
            line-height: 30px;
            background-color: #F5F5F5;
            color: #333;
            padding: 2px 25px 2px 10px;
            position: relative;
            border: 1px solid #ddd;
            transition: all 0.2s ease-in;
            margin-right: 8px;

            .icon-button {
                position: absolute;
                right: 5px;
                top: 2px;
                padding: 0 2px;
                font-size: 15px;
                cursor: pointer;
                transition: all 0.2s ease-in;
                opacity: 0.1;

                &:hover {
                    color: #0288d1;
                    transform: scale(1.2);
                }
            }

            &:hover {
                border: 1px solid #4dd0e1;
                background-color: #e0f7fa;

                .icon-button {
                    opacity: 1;
                }
            }
        }
    }
</style>
